'use strict';
const _ = require('lodash'),
    Backbone = require('backbone')
    ;
module.exports = _.extend({}, Backbone.Events);



// WEBPACK FOOTER //
// ./app/scripts/PubSub.js